import { Switch } from '@/global/components/Switch'
import { CategoriaEnum } from '@acme/auth'
import React from 'react'
import { EntradaSaidaManutencaoProps } from './types'

const EntradaDiaSeguinte: React.FC<EntradaSaidaManutencaoProps> = ({
    categoria,
    saidaDiaAnterior,
    entradaDiaSeguinte,
    isLoading,
    toggle,
}) => {
    if (categoria === CategoriaEnum.Funcionario) return null

    return (
        <Switch
            label="Entrada no dia seguinte"
            checked={entradaDiaSeguinte === 'S'}
            disabled={saidaDiaAnterior === 'S' || isLoading}
            onChange={() => toggle('entrada-dia-seguinte')}
        />
    )
}

export default EntradaDiaSeguinte
